
import "../../../Foundation/stylable/default-scroll-bar.st.css.js";
import "../../../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_LayoutBlocksContent";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_LayoutBlocksContent__root","defaultScrollBar":"wds_1_220_2_defaultscrollbar__defaultScrollBar","innerContent":"wds_1_220_2_LayoutBlocksContent__innerContent","topDivider":"wds_1_220_2_LayoutBlocksContent__topDivider","bottomDivider":"wds_1_220_2_LayoutBlocksContent__bottomDivider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




